// removed by extract-text-webpack-plugin
module.exports = {"layoutWrapperMain":"styles__layoutWrapperMain__3_VG8","root":"styles__root__3TVs2","container":"styles__container__2RfOm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CongratPurchaseBookingPage/styles.css
// module id = 2492
// module chunks = 0